import { SELECT_EVENT } from '../actions/event';
export var selectedEvent = function selectedEvent() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case SELECT_EVENT:
      return action.id;
    default:
      return state;
  }
};